import { render, staticRenderFns } from "./DefaultFooter.vue?vue&type=template&id=5442742e&scoped=true"
import script from "./DefaultFooter.vue?vue&type=script&lang=ts"
export * from "./DefaultFooter.vue?vue&type=script&lang=ts"
import style0 from "./DefaultFooter.vue?vue&type=style&index=0&id=5442742e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5442742e",
  null
  
)

export default component.exports